import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import TollOutlinedIcon from '@mui/icons-material/TollOutlined';
import { Badge, Box, Button, SxProps, Theme, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import {
  getCreditsLeftOfText,
  getViewPicksLabel,
  MARKETPLACE_TOTAL_CREDITS,
  TOOLBAR_CONTROL_SX,
  WALLET_BADGE_SX,
} from '../../../constants/marketplace';

interface IProps {
  remaining: number;
  onClick?: () => void;
  pickCount?: number;
  sx?: SxProps<Theme>;
}

const spendRowSx: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 0.75 };

// No theme variant matches the 17px readout.
const valueSx: SxProps<Theme> = { fontSize: 17, fontWeight: 500, lineHeight: 1, color: 'text.primary' };

const buttonSx: SxProps<Theme> = { gap: 2 };

export const WalletMeter: React.FC<IProps> = ({ remaining, onClick, pickCount = 0, sx }) => {
  const hasSpent = remaining < MARKETPLACE_TOTAL_CREDITS;

  const meter = useMemo(
    () => (
      <Box sx={spendRowSx}>
        <TollOutlinedIcon sx={{ fontSize: 19, color: 'text.primary' }} />
        <Typography component="span" sx={valueSx}>
          {remaining}
        </Typography>
        <Typography component="span" variant="body2" color="text.secondary">
          {hasSpent ? getCreditsLeftOfText(MARKETPLACE_TOTAL_CREDITS) : 'credits to spend'}
        </Typography>
      </Box>
    ),
    [remaining, hasSpent],
  );

  if (!onClick) {
    return <Box sx={sx}>{meter}</Box>;
  }

  return (
    <Button
      onClick={onClick}
      aria-haspopup="dialog"
      aria-label={getViewPicksLabel(pickCount)}
      sx={[TOOLBAR_CONTROL_SX, buttonSx, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Badge badgeContent={pickCount} color="primary" sx={WALLET_BADGE_SX}>
        <ShoppingBagOutlinedIcon sx={{ fontSize: 20, color: 'action.active' }} />
      </Badge>
      {meter}
    </Button>
  );
};
